module.exports = __webpack_public_path__ + "assets/img/th-be91aeeb.png";